import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DeviceCartProduct, DeviceFeature, Role} from '@kion/data-models';
import {BehaviorSubject} from 'rxjs';

@Component({
  selector: 'kion-feature-quote-list-item',
  templateUrl: './feature-quote-list-item.component.html',
  styleUrls: ['./feature-quote-list-item.component.scss']
})
export class FeatureQuoteListItemComponent {

  @Input() entry: DeviceCartProduct;
  @Input() features: DeviceFeature[];
  @Input() roles: Role[];
  @Input() deviceFeatures: DeviceFeature[];
  @Input() disableDelete = false;
  @Input() disableHealthyCheck = false;

  healthySubject$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  // tslint:disable-next-line:no-output-rename
  @Output('deleteFeature') deleteFeatureEmitter: EventEmitter<number> = new EventEmitter<number>();

  get featureDetail(): DeviceFeature {
    return this.features?.find(feature => feature.code === this.entry?.product?.code)
  }

  get canDelete(): boolean {
    if(this.disableDelete){
      return false;
    }
    if (this.roles.map(role => role.role.uid).includes('fsNwpBuyer')) {
      return true
    }
    return this.roles.map(role => role.role.uid).includes('fsNwpApprover');
  }

  get feature(): DeviceFeature {
    if (this.deviceFeatures && this.featureDetail) {
      return this.deviceFeatures.find(feature => feature.id === this.featureDetail.code)
    }
  }

  get isHealthy(): boolean {
    if(this.disableHealthyCheck){
      return true;
    }
    let healthy = false;
    if (this.feature && this.feature.status) {
      healthy = this.feature.status === 'AVAILABLE'
    }
    if (this.feature && this.feature.truckHealthManagement) {
      healthy = this.feature.truckHealthManagement.status === 'AVAILABLE'
    }
    this.healthySubject$.next(healthy);
    return healthy;
  }

  deleteFeatureClicked() {
    this.deleteFeatureEmitter.emit(this.entry.entryNumber);
  }
}
